import { Button, Drawer, Dropdown, Menu, Modal, QRCode, Space, Switch, Table, Tooltip } from "antd";
import {
  IconPalette,
  IconSearch,
  IconSortAscending,
} from "@tabler/icons-react";
import { Input, Button as MantineButton, TextInput } from "@mantine/core";
import React, { useCallback, useEffect, useState } from "react";
import {
  apiUserDeleteMaterialBOM,
  apiUserGetAccountsProject,
  apiUserGetAccountsProjectNode,
  apiUserGetSteelBolt,
  apiUserGetSteelBolts,
} from "@/api";

import ChatBot from "@/components/ChatBot";
import Feature from "@/components/Feature";
import ProductionPlanFlow from "@/pages/ProductionPlanFlow";
import ProductionResumeTable from "@/components/ProductionResumeTable";
import { ReactFlowProvider } from "@xyflow/react";
import { SelectionProvider } from "@/contexts/SelectionContext";
import aiAgentIcon from "/Logo/ai_agent.png";
import { orpcClient } from "@/lib/orpc-client";
import { single } from "@/lib/orpc-batch";
import { useParams } from "react-router-dom";
import { useProjectIfc3d, assemblyMarks } from "@/components/useProjectIfc3d";
import { useTranslation } from "react-i18next";

interface MenuItem {
  key: string;
  label: string;
  children?: MenuItem[];
}

interface DesignBOMData {
  documentId: string;
  steelAssembly?: {
    steelAssemblyId?: string;
    steelAssemblyCode?: string;
    installationLocation?: string;
    installationElevation?: number;
    distinction?: string;
    transportNumber?: string;
    transportDescription?: string;
    drawingName?: string;
    totalWidth?: number;
    totalHeight?: number;
    totalLength?: number;
    totalWeight?: number;
    totalArea?: number;
    guandaId?: number;
    metricSizeMark?: string;
  };
}

type NodeType = "building" | "zone" | "batch" | "package";

const COLOR_PALETTE = [
  "#ef4444",
  "#f97316",
  "#f59e0b",
  "#eab308",
  "#84cc16",
  "#22c55e",
  "#06b6d4",
  "#3b82f6",
  "#8b5cf6",
  "#ec4899",
];

function ProductionPlan() {
  const { t } = useTranslation();
  const [openSteelAssembly, setOpenSteelAssembly] = useState(false);
  const [openDesignBOM, setOpenDesignBOM] = useState(false);
  const [openProductionResume, setOpenProductionResume] = useState(false);
  const [designBomData, setDesignBomData] = useState<DesignBOMData[]>([]);
  const [allDesignBomData, setAllDesignBomData] = useState<DesignBOMData[]>([]);
  const [steelBoltData, setSteelBoltData] = useState<any[]>([]);
  const [stateOpenKeys, setStateOpenKeys] = useState<string[]>(["2", "23"]);
  const [totalItems, setTotalItems] = useState(0);
  const [steelAssemblyList, setSteelAssemblyList] = useState<string[]>([]);
  const [buildingNodeId, setBuildingNodeId] = useState<string>("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [filters, setFilters] = useState({
    guandaId: "",
    steelAssemblyCode: "",
    distinction: "",
    transportNumber: "",
    metricSizeMark: "",
  });
  const [loading, setLoading] = useState(false);
  const [selectedDesignBOMRows, setSelectedDesignBOMRows] = useState<any[]>([]);
  const [selectedDesignBOMKeys, setSelectedDesignBOMKeys] = useState<React.Key[]>([]);
  const [qrCodePopup, setQrCodePopup] = useState<{
    visible: boolean;
    guandaId: number | null;
    code: string | null;
  }>({ visible: false, guandaId: null, code: null });
  const [projectAttachments, setProjectAttachments] = useState<any[]>([]);
  const [layerColor, setLayerColor] = useState<Record<NodeType, string>>({
    building: "#d1d5db",
    zone: "#d1d5db",
    batch: "#d1d5db",
    package: "#d1d5db",
  });

  console.log("allDesignBomData", allDesignBomData);
  const [activeColorPicker, setActiveColorPicker] = useState<NodeType | null>(
    null
  );
  const [showLayerColorPanel, setShowLayerColorPanel] = useState(false);
  const [isLayerColorLoaded, setIsLayerColorLoaded] = useState(false);
  const [showQRCode, setShowQRCode] = useState(false);
  const [isPriorityModalOpen, setIsPriorityModalOpen] = useState(false);
  const [chatOpen, setChatOpen] = useState(false);
  const [flowReloadKey, setFlowReloadKey] = useState(0);
  const [projectName, setProjectName] = useState("");
  const [selectedNode, setSelectedNode] = useState<{
    id: string;
    name: string;
    type?: string;
  } | null>(null);

  const handleSelectedNodeChange = useCallback(
    (node: { id: string; name: string; type?: string } | null) => {
      setSelectedNode((prev) => {
        if (prev?.id === node?.id && prev?.name === node?.name) return prev;
        return node;
      });
    },
    []
  );

  const getLevelKeys = (items1: MenuItem[]) => {
    const key: Record<string, number> = {};
    const func = (items2: MenuItem[], level = 1) => {
      items2.forEach((item) => {
        if (item.key) {
          key[item.key] = level;
        }
        if (item.children) {
          func(item.children, level + 1);
        }
      });
    };
    func(items1);
    return key;
  };

  const onOpenChange = (openKeys: string[]) => {
    const currentOpenKey = openKeys.find(
      (key) => stateOpenKeys.indexOf(key) === -1
    );
    if (currentOpenKey !== undefined) {
      const repeatIndex = openKeys
        .filter((key) => key !== currentOpenKey)
        .findIndex((key) => levelKeys[key] === levelKeys[currentOpenKey]);
      setStateOpenKeys(
        openKeys
          .filter((_, index) => index !== repeatIndex)
          .filter((key) => levelKeys[key] <= levelKeys[currentOpenKey])
      );
    } else {
      setStateOpenKeys(openKeys);
    }
  };

  const { id } = useParams();
  const ifc3d = useProjectIfc3d(id, openDesignBOM);

  const steelBoltColumns = [
    {
      title: t("productionPlan.materialSpec") || "材質規格-直徑-長度",
      dataIndex: "materialSpec",

      render: (text, i) => {
        return i?.materialSpec?.trim();
        return rowEditDisplay(
          <Input
            placeholder="Input component"
            //leftSection={<IconMail size={16} />}
            value={editRowData?.materialSpec?.trim()}
            onChange={(e) =>
              handleChangePayableDetail(
                i?.documentId || i?.key,
                e.target.value,
                "materialSpec"
              )
            }
          />,
          i,
          i?.materialSpec
        );
      },
    },
    {
      title: t("productionPlan.type") || "類型",
      dataIndex: "type",
      render: (text, i) => {
        return i?.type?.trim();
        return rowEditDisplay(
          <Input
            placeholder="Input component"
            //leftSection={<IconMail size={16} />}
            value={editRowData?.type?.trim()}
            onChange={(e) =>
              handleChangePayableDetail(
                i?.documentId || i?.key,
                e.target.value,
                "type"
              )
            }
          />,
          i,
          i?.type
        );
      },
    },
    {
      title: t("productionPlan.quantity") || "數量",
      dataIndex: "quantity",
      render: (text, i) => {
        return Number(i?.quantity);
        return rowEditDisplay(
          <Input
            placeholder="Input component"
            //leftSection={<IconMail size={16} />}
            value={Number(editRowData?.quantity)}
            onChange={(e) =>
              handleChangePayableDetail(
                i?.documentId || i?.key,
                e.target.value,
                "quantity"
              )
            }
          />,
          i,
          i?.quantity
        );
      },
    },
    {
      title: t("productionPlan.material") || "材質",
      dataIndex: "material",
      render: (text, i) => {
        return i?.material;
        return rowEditDisplay(
          <Input
            placeholder="Input component"
            //leftSection={<IconMail size={16} />}
            value={editRowData?.material}
            onChange={(e) =>
              handleChangePayableDetail(
                i?.documentId || i?.key,
                e.target.value,
                "material"
              )
            }
          />,
          i,
          i?.material
        );
      },
    },
    {
      title: t("productionPlan.unitWeight") || "單位重(kg/m)",
      dataIndex: "unitWeight",
      render: (text, i) => {
        return i?.unitWeight;
        return rowEditDisplay(
          <Input
            placeholder="Input component"
            //leftSection={<IconMail size={16} />}
            value={editRowData?.unitWeight}
            onChange={(e) =>
              handleChangePayableDetail(
                i?.documentId || i?.key,
                e.target.value,
                "unitWeight"
              )
            }
          />,
          i,
          i?.unitWeight
        );
      },
    },
  ];

  const columns = [
    // {
    //   title: '構件ID',
    //   dataIndex: 'name',

    //   render: (text, i) => {
    //     return (
    //       <Input
    //         placeholder="Input component"
    //         //leftSection={<IconMail size={16} />}
    //         value={i?.name}
    //         onChange={(e) =>
    //           handleChangePayableDetail(i?.documentId || i?.key, e.target.value, 'name')
    //         }
    //       />
    //     );
    //   },
    // },
    {
      title: t("steelAssemblyBOM.componentId") || "構件ID",
      dataIndex: "steelAssemblyId",

      render: (text, i) => {
        return i?.steelAssemblyId?.trim();
        return (
          <Input
            placeholder="Input component"
            disabled={true}
            //leftSection={<IconMail size={16} />}
            value={i?.steelAssemblyId?.trim()}
          />
        );
      },
    },
    {
      title: "廣達ID",
      dataIndex: "guandaId",
      render: (text, i) => {
        if (!i?.guandaId) return null;
        return (
          <span
            style={{ color: "#1677ff", cursor: "pointer", textDecoration: "underline" }}
            onClick={() =>
              setQrCodePopup({
                visible: true,
                guandaId: i.guandaId,
                code: i.steelAssemblyCode,
              })
            }
          >
            {i?.guandaId?.toString().padStart(7, "0")}
          </span>
        );
      },
    },
    {
      title: t("steelAssemblyBOM.componentCode") || "構件編號",
      dataIndex: "steelAssemblyCode",

      render: (text, i) => {
        return i?.steelAssemblyCode?.trim();
        return (
          <Input
            placeholder="Input component"
            disabled={true}
            //leftSection={<IconMail size={16} />}
            value={i?.steelAssemblyCode?.trim()}
          />
        );
      },
    },
    {
      title: t("steelAssemblyBOM.installationLocation") || "安裝位置",
      dataIndex: "installationLocation",
      render: (text, i) => {
        return i?.installationLocation;
        return (
          <Input
            disabled={true}
            placeholder="Input component"
            //leftSection={<IconMail size={16} />}
            value={i?.installationLocation}
          />
        );
      },
    },
    {
      title: t("steelAssemblyBOM.installationElevation") || "安裝高程",
      dataIndex: "installationElevation",
      render: (text, i) => {
        return i?.installationElevation;
        return (
          <Input
            disabled={true}
            placeholder="Input component"
            //leftSection={<IconMail size={16} />}
            value={i?.installationElevation}
          />
        );
      },
    },
    {
      title: t("steelAssemblyBOM.distinction") || "區別",
      dataIndex: "distinction",
      render: (text, i) => {
        return i?.distinction;
        return (
          <Input
            disabled={true}
            placeholder="Input component"
            value={i?.distinction}
          />
        );
      },
    },
    {
      title: t("steelAssemblyBOM.transportNumber") || "拆運號碼",
      dataIndex: "transportNumber",
      render: (text, i) => {
        return i?.transportNumber;
        return (
          <Input
            disabled={true}
            placeholder="Input component"
            //leftSection={<IconMail size={16} />}
            value={i?.transportNumber}
          />
        );
      },
    },
    {
      title: t("steelAssemblyBOM.transportDescription") || "拆運說明",
      dataIndex: "transportDescription",
      render: (text, i) => {
        return i?.transportDescription;
        return (
          <Input
            disabled={true}
            placeholder="Input component"
            //leftSection={<IconMail size={16} />}
            value={i?.transportDescription}
          />
        );
      },
    },
    {
      title: t("steelAssemblyBOM.drawingName") || "圖面名稱",
      dataIndex: "drawingName",
      render: (text, i) => {
        const matchingPdf = findMatchingPdf(i?.drawingName);
        if (matchingPdf) {
          return (
            <a
              href={matchingPdf.url}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#1890ff", textDecoration: "underline" }}
            >
              {i?.drawingName}
            </a>
          );
        }
        return i?.drawingName;
      },
    },
    ...(ifc3d.enabled
      ? [
          {
            title: ifc3d.title,
            dataIndex: "model3d",
            render: (_: unknown, i: any) => ifc3d.render3dCell(assemblyMarks(i)),
          },
        ]
      : []),
    {
      title: t("steelAssemblyBOM.totalWidth") || "總寬度",
      dataIndex: "totalWidth",
      render: (text, i) => {
        return i?.totalWidth;
        return (
          <Input
            disabled={true}
            placeholder="Input component"
            //leftSection={<IconMail size={16} />}
            value={i?.totalWidth}
          />
        );
      },
    },
    {
      title: t("steelAssemblyBOM.totalHeight") || "總高度",
      dataIndex: "totalHeight",
      render: (text, i) => {
        return i?.totalHeight;
        return (
          <Input
            disabled={true}
            placeholder="Input component"
            //leftSection={<IconMail size={16} />}
            value={i?.totalHeight}
          />
        );
      },
    },
    {
      title: t("steelAssemblyBOM.totalLength") || "總長度",
      dataIndex: "totalLength",
      render: (text, i) => {
        return i?.totalLength;
        return (
          <Input
            disabled={true}
            placeholder="Input component"
            //leftSection={<IconMail size={16} />}
            value={i?.totalLength}
          />
        );
      },
    },
    {
      title: t("steelAssemblyBOM.totalWeight") || "總重量",
      dataIndex: "totalWeight",
      render: (text, i) => {
        return i?.totalWeight;
        return (
          <Input
            disabled={true}
            placeholder="Input component"
            //leftSection={<IconMail size={16} />}
            value={i?.totalWeight}
          />
        );
      },
    },
    {
      title: t("steelAssemblyBOM.totalArea") || "總面積",
      dataIndex: "totalArea",
      render: (text, i) => {
        return i?.totalArea;
        return (
          <Input
            disabled={true}
            placeholder="Input component"
            //leftSection={<IconMail size={16} />}
            value={i?.totalArea}
          />
        );
      },
    },
    {
      title: t("productionPlan.sectionSpecification") || "斷面規格",
      dataIndex: "metricSizeMark",
      render: (text, i) => {
        return i?.metricSizeMark;
        return (
          <Input
            disabled={true}
            placeholder="Input component"
            //leftSection={<IconMail size={16} />}
            value={i?.metricSizeMark}
          />
        );
      },
    },
    // {
    //   title: '',
    //   fixed: 'right',
    //   render: (text, i) => {
    //     return (
    //       <>
    //         {editRowId ? (
    //           <Button
    //             variant="default"
    //             style={{ marginRight: '15px' }}
    //             onClick={() => {
    //               setEditRowId(null);
    //               setEditRowData([]);
    //             }}
    //           >
    //             取消
    //           </Button>
    //         ) : (
    //           <Button
    //             variant="default"
    //             style={{ marginRight: '15px' }}
    //             onClick={() => {
    //               setEditRowId(i?.id);
    //               setEditRowData(i);
    //             }}
    //           >
    //             編輯
    //           </Button>
    //         )}
    //         <Button
    //           variant="default"
    //           onClick={async (element) => {
    //             const result = await apiUserPutMaterialBOM({
    //               id: i?.documentId,
    //               data: {
    //                 steelAssembly: {
    //                   steelAssemblyId: String(i?.steelAssemblyId),
    //                   steelAssemblyCode: i?.steelAssemblyCode,
    //                   installationLocation: i?.installationLocation,
    //                   installationElevation: Number(
    //                     i?.installationElevation,
    //                   ),
    //                   distinction: String(i?.distinction),
    //                   transportNumber: i?.transportNumber,
    //                   transportDescription: i?.transportDescription,
    //                   drawingName: i?.drawingName,
    //                   totalWidth: i?.totalWidth,
    //                   totalHeight: i?.totalHeight,
    //                   totalLength: i?.totalLength,
    //                   totalWeight: i?.totalWeight,
    //                   totalArea: i?.totalArea,
    //                 },
    //               },
    //             });

    //             if (result?.data) {
    //               api.success({
    //                 message: `Notification `,
    //                 description: <div>編輯成功</div>,
    //                 placement: 'topLeft',
    //                 duration: 0,
    //               });
    //             } else {
    //               api.error({
    //                 message: `Notification `,
    //                 description: <div>編輯失敗</div>,
    //                 placement: 'topLeft',
    //                 duration: 0,
    //               });
    //             }

    //             fetchData();
    //             setEditRowId(null);
    //             setEditRowData([]);
    //           }}
    //         >
    //           儲存
    //         </Button>
    //       </>
    //     );
    //   },
  ];

  const fetchChildSteelAssemblyDetails = async (childNodeIds: string[]) => {
    try {
      const childDetails = await Promise.all(
        childNodeIds.map(async (nodeId) => {
          const result = await apiUserGetAccountsProjectNode({
            id: nodeId?.documentId,
          });
          if (result?.data) {
            // Get current node's steel assembly details
            const currentSteelAssemblies = result.data.steelAssemblyList || [];

            // If this node has children, recursively fetch their details
            let childNodeDetails = [];
            if (result.data.childNodes && result.data.childNodes.length > 0) {
              childNodeDetails = await fetchChildSteelAssemblyDetails(
                result.data.childNodes
              );
            }

            return [...currentSteelAssemblies, ...childNodeDetails].filter(
              Boolean
            );
          }
          return [];
        })
      );
      return childDetails.flat();
    } catch (error) {
      console.error("Error fetching child steel assembly details:", error);
      return [];
    }
  };

  const fetchBuildingNodeId = async () => {
    try {
      const result = await apiUserGetAccountsProject({ id });
      if (result?.data) {
        // Find the building node
        const buildingNode = result.data?.productionPlan?.nodes?.find(
          (node) => node.type === "building"
        );
        if (buildingNode) {
          setBuildingNodeId(buildingNode.documentId);
        }
      }
    } catch (error) {
      console.error("Error fetching building node:", error);
    }
  };

  const fetchSteelAssemblyList = async () => {
    if (!buildingNodeId) return;

    try {
      const result = await apiUserGetAccountsProjectNode({
        id: buildingNodeId,
      });
      if (result?.data) {
        // Get current node's steel assembly details
        const currentSteelAssemblies = result.data.steelAssemblyList || [];

        let childDetails = [];
        if (result.data.childNodes && result.data.childNodes.length > 0) {
          childDetails = await fetchChildSteelAssemblyDetails(
            result.data.childNodes
          );
        }

        const allSteelAssemblies = [
          ...currentSteelAssemblies,
          ...childDetails,
        ].filter(Boolean);
        setSteelAssemblyList(allSteelAssemblies);
      }
    } catch (error) {
      console.error("Error fetching steel assembly list:", error);
    }
  };

  const fetchProjectAttachments = async () => {
    if (!id) return;
    try {
      const projectData = await single(orpcClient.project.read([{ id: id! }]));
      if (projectData?.attachment) {
        setProjectAttachments(projectData.attachment as any[]);
      }
    } catch (error) {
      console.error("Error fetching project attachments:", error);
    }
  };

  const findMatchingPdf = (drawingName: string) => {
    if (!drawingName || !projectAttachments?.length) return null;
    return projectAttachments.find((file: any) => {
      if (!file?.name || !file?.url) return false;
      const isPdf = file.name.toLowerCase().endsWith(".pdf");
      if (!isPdf) return false;
      const fileNameWithoutExt = file.name.replace(/\.pdf$/i, "");
      return fileNameWithoutExt.trim() === drawingName.trim();
    });
  };

  const fetchData = async (page = currentPage, size = pageSize) => {
    setLoading(true);
    try {
      const projectData = await single(orpcClient.project.read([{ id: id! }]));

      let allData = await orpcClient.steelAssembly.list({
        filter: {
          buildingId: projectData?.projectNode?.filter(
            (t) => t?.nodeType === "building"
          )[0]?.id,
        },
      });

      let filteredData = allData.filter((item) => {
        const steelAssembly = item;
        if (!steelAssembly) return false;

        if (
          filters.guandaId &&
          !steelAssembly.guandaId?.toString().includes(filters.guandaId.trim())
        ) {
          return false;
        }

        if (
          filters.steelAssemblyCode &&
          !steelAssembly.steelAssemblyCode
            ?.toLowerCase()
            .includes(filters.steelAssemblyCode.toLowerCase().trim())
        ) {
          return false;
        }

        if (
          filters.distinction &&
          !steelAssembly.distinction
            ?.toLowerCase()
            .includes(filters.distinction.toLowerCase().trim())
        ) {
          return false;
        }

        if (
          filters.transportNumber &&
          !steelAssembly.transportNumber
            ?.toLowerCase()
            .includes(filters.transportNumber.toLowerCase().trim())
        ) {
          return false;
        }

        if (
          filters.metricSizeMark &&
          !steelAssembly.metricSizeMark
            ?.toLowerCase()
            .includes(filters.metricSizeMark.toLowerCase().trim())
        ) {
          return false;
        }

        return true;
      });

      console.log("result", filteredData);

      const totalCount = filteredData.length;
      setTotalItems(totalCount);

      setDesignBomData(filteredData);

      // Filter out items that are already in steelAssemblyList
      const steelIdSet = new Set(
        steelAssemblyList.map((item) => item.documentId)
      );
      const finalFilteredData = filteredData.filter(
        (item) => !steelIdSet.has(item.id)
      );
      setAllDesignBomData(finalFilteredData);
    } catch (error) {
      console.error("Error fetching department data:", error);
    } finally {
      setLoading(false);
    }
  };

  // Apply filters and fetch data
  const applyFiltersAndFetch = () => {
    // Reset to first page when filtering
    setCurrentPage(1);
    fetchData(1, pageSize);
  };

  const handleAiDataChanged = () => {
    setFlowReloadKey((k) => k + 1);
    fetchData(currentPage, pageSize);
    fetchBuildingNodeId();
    fetchSteelAssemblyList();
  };

  const fetchSteelBoltData = async (page = 1) => {
    try {
      let result = await apiUserGetSteelBolts({ page });

      let data = [];

      const tempPayableList = await Promise.all(
        result?.data.map(async (t) => {
          const result = await apiUserGetSteelBolt({ id: t.documentId });
          data.push(result?.data);
          return result?.data;
        })
      );
      setSteelBoltData(tempPayableList);
    } catch (error) {
      console.error("Error fetching department data:", error);
    }
  };

  const items = [
    {
      key: "1",
      label: t("productionPlan.navigationOne") || "Navigation One",
      children: [
        { key: "11", label: t("productionPlan.option1") || "Option 1" },
        { key: "12", label: t("productionPlan.option2") || "Option 2" },
        { key: "13", label: t("productionPlan.option3") || "Option 3" },
        { key: "14", label: t("productionPlan.option4") || "Option 4" },
      ],
    },
    {
      key: "2",
      label: t("productionPlan.navigationTwo") || "Navigation Two",
      children: [
        { key: "21", label: t("productionPlan.option1") || "Option 1" },
        { key: "22", label: t("productionPlan.option2") || "Option 2" },
        {
          key: "23",
          label: t("productionPlan.submenu") || "Submenu",
          children: [
            { key: "231", label: t("productionPlan.option1") || "Option 1" },
            { key: "232", label: t("productionPlan.option2") || "Option 2" },
            { key: "233", label: t("productionPlan.option3") || "Option 3" },
          ],
        },
        {
          key: "24",
          label: t("productionPlan.submenu2") || "Submenu 2",
          children: [
            { key: "241", label: t("productionPlan.option1") || "Option 1" },
            { key: "242", label: t("productionPlan.option2") || "Option 2" },
            { key: "243", label: t("productionPlan.option3") || "Option 3" },
          ],
        },
      ],
    },
    {
      key: "3",
      label: t("productionPlan.navigationThree") || "Navigation Three",
      children: [
        { key: "31", label: t("productionPlan.option1") || "Option 1" },
        { key: "32", label: t("productionPlan.option2") || "Option 2" },
        { key: "33", label: t("productionPlan.option3") || "Option 3" },
        { key: "34", label: t("productionPlan.option4") || "Option 4" },
      ],
    },
  ];

  const handlePageChange = (page: number, size?: number) => {
    setCurrentPage(page);
    if (size && size !== pageSize) {
      setPageSize(size);
      fetchData(page, size);
    } else {
      fetchData(page, pageSize);
    }
  };

  const handleSort = (key: string) => {
    const sortedData = [...allDesignBomData].sort((a, b) => {
      if (key === "steelAssemblyCode_asc") {
        const codeA = a?.steelAssemblyCode || "";
        const codeB = b?.steelAssemblyCode || "";
        return codeA.localeCompare(codeB);
      } else if (key === "steelAssemblyId_asc") {
        const idA = a?.steelAssemblyId || "";
        const idB = b?.steelAssemblyId || "";
        return idA.localeCompare(idB);
      }
      return 0;
    });
    setAllDesignBomData(sortedData);
  };

  const menu = (
    <Menu
      onClick={({ key }) => handleSort(key)}
      items={[
        {
          label: t("productionPlan.sortByComponentCode") || "構件編號 (A-Z)",
          key: "steelAssemblyCode_asc",
        },
        {
          label: t("productionPlan.sortByComponentId") || "構件ID (A-Z)",
          key: "steelAssemblyId_asc",
        },
      ]}
    />
  );

  const levelKeys = getLevelKeys(items);

  useEffect(() => {
    fetchBuildingNodeId();
    fetchProjectAttachments();
  }, [id]);

  useEffect(() => {
    if (buildingNodeId) {
      fetchSteelAssemblyList();
    }
  }, [buildingNodeId, openDesignBOM]);

  useEffect(() => {
    if (buildingNodeId) {
      fetchData(1, pageSize);
    }
  }, [buildingNodeId]);

  useEffect(() => {
    if (steelAssemblyList.length > 0) {
      fetchData(currentPage, pageSize);
    }
  }, [steelAssemblyList]);

  useEffect(() => {
    const delayTimer = setTimeout(() => {
      if (openDesignBOM) {
        setCurrentPage(1);
        fetchData(1, pageSize);
      }
    }, 300);

    return () => clearTimeout(delayTimer);
  }, [filters, openDesignBOM]);

  useEffect(() => {
    const loadLayerColors = async () => {
      try {
        if (!id) return;
        const result = await single(orpcClient.project.read([{ id: id! }]));
        if (result?.layerColor) {
          setLayerColor(result.layerColor as Record<NodeType, string>);
        }
        setProjectName((result as any)?.name ?? "");
        setIsLayerColorLoaded(true);
      } catch (error) {
        console.error("Error loading layer colors:", error);
        setIsLayerColorLoaded(true);
      }
    };

    loadLayerColors();
  }, [id]);

  useEffect(() => {
    if (!isLayerColorLoaded) return;

    const saveLayerColors = async () => {
      try {
        if (!id) return;
        await single(
          orpcClient.project.update([
            {
              id: id || "",
              layerColor: layerColor,
            },
          ]),
        );
      } catch (error) {
        console.error("Error saving layer colors:", error);
      }
    };

    saveLayerColors();
  }, [layerColor, isLayerColorLoaded]);

  // useEffect(() => {
  //   fetchSteelBoltData();
  // }, []);

  return (
    <SelectionProvider>
      <div className="flex h-screen w-full overflow-hidden">
        <div className="min-w-0 flex-1 overflow-auto">
          <div>
            <ReactFlowProvider>
              <ProductionPlanFlow
                designBomData={designBomData}
                layerColor={layerColor}
                showQRCode={showQRCode}
                isPriorityModalOpen={isPriorityModalOpen}
                setIsPriorityModalOpen={setIsPriorityModalOpen}
                onSelectedNodeChange={handleSelectedNodeChange}
                reloadKey={flowReloadKey}
              />
            </ReactFlowProvider>
          </div>

          <div
            style={{
              margin: "1rem",
              display: "flex",
              gap: "0.5rem",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
              <Button onClick={() => setOpenDesignBOM(true)}>
                {t("productionPlan.designBOM") || "設計BOM"}
              </Button>
              <Button onClick={() => setOpenProductionResume(true)}>
                {t("productionPlan.productionResume") || "生產履歷"}
              </Button>
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
              <Feature flag="genAiChat">
                <Tooltip title={t("productionPlan.aiAssistant") || "AI 助理"}>
                  <Button
                    type="default"
                    shape="circle"
                    icon={
                      <img
                        src={aiAgentIcon}
                        alt={t("productionPlan.aiAssistant") || "AI 助理"}
                        style={{ width: 20, height: 20, objectFit: "contain" }}
                      />
                    }
                    onClick={() => setChatOpen((o) => !o)}
                  />
                </Tooltip>
              </Feature>
              <Tooltip title={t("productionPlan.showQRCode")}>
                <Switch
                  checked={showQRCode}
                  onChange={setShowQRCode}
                />
              </Tooltip>
              <Button onClick={() => setIsPriorityModalOpen(true)}>
                {t("productionPlanFlow.priorityMode")}
              </Button>
              <MantineButton
                variant="filled"
                color="blue"
                onClick={() => setShowLayerColorPanel(!showLayerColorPanel)}
              >
                {t("productionPlanFlow.layerColors") || "圖層顏色"}
              </MantineButton>
            </div>
          </div>

          {showLayerColorPanel && (
            <div
              style={{
                position: "fixed",
                bottom: "80px",
                right: "calc(var(--chat-docked-width, 0px) + 20px)",
                transition: "right 300ms ease-in-out",
                backgroundColor: "white",
                border: "1px solid #d1d5db",
                borderRadius: "8px",
                padding: "16px",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                zIndex: 10,
                minWidth: "200px",
              }}
            >
              <div
                style={{
                  fontWeight: "bold",
                  marginBottom: "12px",
                  fontSize: "14px",
                }}
              >
                {t("productionPlanFlow.layerColors") || "圖層顏色"}
              </div>

              {(
                ["building", "zone", "batch", "package"] as NodeType[]
              ).map((layerType) => (
                <div key={layerType} style={{ marginBottom: "12px" }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      cursor: "pointer",
                      padding: "4px",
                      borderRadius: "4px",
                      transition: "background-color 0.2s",
                    }}
                    onClick={() => {
                      setActiveColorPicker(
                        activeColorPicker === layerType ? null : layerType
                      );
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#f3f4f6";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "transparent";
                    }}
                  >
                    <div
                      style={{
                        width: "24px",
                        height: "24px",
                        borderRadius: "50%",
                        backgroundColor: layerColor[layerType],
                        border: "2px solid #e5e7eb",
                        flexShrink: 0,
                      }}
                    />
                    <span style={{ fontSize: "13px" }}>
                      {t(`productionPlanFlow.${layerType}`) || layerType}
                    </span>
                  </div>

                  {activeColorPicker === layerType && (
                    <div
                      style={{
                        marginTop: "8px",
                        padding: "8px",
                        backgroundColor: "#f9fafb",
                        borderRadius: "4px",
                        display: "grid",
                        gridTemplateColumns: "repeat(5, 1fr)",
                        gap: "8px",
                      }}
                    >
                      {COLOR_PALETTE.map((color) => (
                        <div
                          key={color}
                          style={{
                            width: "28px",
                            height: "28px",
                            borderRadius: "50%",
                            backgroundColor: color,
                            border:
                              layerColor[layerType] === color
                                ? "3px solid #374151"
                                : "2px solid #e5e7eb",
                            cursor: "pointer",
                            transition: "transform 0.2s",
                          }}
                          onClick={() => {
                            setLayerColor((prev) => ({
                              ...prev,
                              [layerType]: color,
                            }));
                            setActiveColorPicker(null);
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = "scale(1.1)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "scale(1)";
                          }}
                        />
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
          {/* <Button style={{ margin: '1rem' }} onClick={() => setOpenSteelAssembly(true)}>
            {t('productionPlan.boltBOM') || '螺絲BOM'}
          </Button> */}
          <Drawer
            title={t("productionPlan.designBOM") || "設計BOM"}
            placement="bottom"
            height={700}
            width={500}
            onClose={() => setOpenDesignBOM(false)}
            open={openDesignBOM}
            extra={
              <Space>
                <Button onClick={() => setOpenDesignBOM(false)}>
                  {t("productionPlan.cancel") || "Cancel"}
                </Button>
                <Button type="primary" onClick={() => setOpenDesignBOM(false)}>
                  {t("productionPlan.ok") || "OK"}
                </Button>
              </Space>
            }
          >
            <div className="flex w-full items-center">
              {/* <div className="w-[25%] p-4">
                <Menu
                  mode="inline"
                  defaultSelectedKeys={["231"]}
                  openKeys={stateOpenKeys}
                  onOpenChange={onOpenChange}
                  //style={{ width: 256 }}
                  items={items}
                />
              </div> */}
              <div className=" w-full p-4 overflow-x-auto">
                <div className="space-y-3 pb-3">
                  <div className="flex items-center justify-between w-full gap-4">
                    <Dropdown dropdownRender={() => menu}>
                      <Button className="flex items-center gap-1">
                        排序
                        <IconSortAscending size={16} />
                      </Button>
                    </Dropdown>

                    {/* <TextInput
                      className="w-64" // adjust width as needed
                      leftSection={<IconSearch size={16} />}
                      // onChange={handleInputChange}
                    /> */}
                  </div>

                  {/* Filter Section */}
                  <div
                    className="flex items-center gap-4 px-3 py-2"
                    style={{ backgroundColor: "#F5F5F5", borderRadius: "6px" }}
                  >
                    <div className="flex items-center gap-2">
                      <span
                        style={{
                          minWidth: "70px",
                          fontWeight: "500",
                          fontSize: "14px",
                        }}
                      >
                        廣達ID:
                      </span>
                      <Input
                        placeholder="搜尋廣達ID"
                        value={filters.guandaId}
                        onChange={(e) =>
                          setFilters((prev) => ({
                            ...prev,
                            guandaId: e.target.value,
                          }))
                        }
                        style={{ width: "120px" }}
                      />
                    </div>

                    <div className="flex items-center gap-2">
                      <span
                        style={{
                          minWidth: "70px",
                          fontWeight: "500",
                          fontSize: "14px",
                        }}
                      >
                        構件編號:
                      </span>
                      <Input
                        placeholder="搜尋構件編號"
                        value={filters.steelAssemblyCode}
                        onChange={(e) =>
                          setFilters((prev) => ({
                            ...prev,
                            steelAssemblyCode: e.target.value,
                          }))
                        }
                        style={{ width: "120px" }}
                      />
                    </div>

                    <div className="flex items-center gap-2">
                      <span
                        style={{
                          minWidth: "70px",
                          fontWeight: "500",
                          fontSize: "14px",
                        }}
                      >
                        區別:
                      </span>
                      <Input
                        placeholder="搜尋區別"
                        value={filters.distinction}
                        onChange={(e) =>
                          setFilters((prev) => ({
                            ...prev,
                            distinction: e.target.value,
                          }))
                        }
                        style={{ width: "120px" }}
                      />
                    </div>

                    <div className="flex items-center gap-2">
                      <span
                        style={{
                          minWidth: "70px",
                          fontWeight: "500",
                          fontSize: "14px",
                        }}
                      >
                        拆運號碼:
                      </span>
                      <Input
                        placeholder="搜尋拆運號碼"
                        value={filters.transportNumber}
                        onChange={(e) =>
                          setFilters((prev) => ({
                            ...prev,
                            transportNumber: e.target.value,
                          }))
                        }
                        style={{ width: "120px" }}
                      />
                    </div>

                    <div className="flex items-center gap-2">
                      <span
                        style={{
                          minWidth: "70px",
                          fontWeight: "500",
                          fontSize: "14px",
                        }}
                      >
                        斷面規格:
                      </span>
                      <Input
                        placeholder="搜尋斷面規格"
                        value={filters.metricSizeMark}
                        onChange={(e) =>
                          setFilters((prev) => ({
                            ...prev,
                            metricSizeMark: e.target.value,
                          }))
                        }
                        style={{ width: "120px" }}
                      />
                    </div>

                    <div className="flex gap-2">
                      <Button
                        size="small"
                        type="primary"
                        onClick={() => applyFiltersAndFetch()}
                      >
                        搜尋
                      </Button>
                      <Button
                        size="small"
                        onClick={() => {
                          setFilters({
                            guandaId: "",
                            steelAssemblyCode: "",
                            distinction: "",
                            transportNumber: "",
                            metricSizeMark: "",
                          });
                          setCurrentPage(1);
                          // Re-fetch data after clearing filters
                          setTimeout(() => fetchData(1, pageSize), 0);
                        }}
                      >
                        清除
                      </Button>
                    </div>
                  </div>
                </div>
                <div style={{ fontSize: "14px", color: "#333", marginBottom: "8px" }}>
                  本專案共 {totalItems} 隻，已選擇 {selectedDesignBOMRows.length} 隻，總重量{" "}
                  {selectedDesignBOMRows
                    .reduce((sum, item) => {
                      const weight = parseFloat(item?.totalWeight) || 0;
                      return sum + weight;
                    }, 0)
                    .toFixed(2)}{" "}
                  kg
                </div>
                <Table
                  rowSelection={{
                    type: "checkbox",
                    preserveSelectedRowKeys: true,
                    selectedRowKeys: selectedDesignBOMKeys,
                    onChange: (keys: React.Key[], rows: any[]) => {
                      setSelectedDesignBOMKeys(keys);
                      setSelectedDesignBOMRows(rows);
                    },
                  }}
                  loading={loading}
                  scroll={{ x: "max-content" }}
                  columns={columns}
                  dataSource={allDesignBomData}
                  pagination={{
                    pageSize: pageSize,
                    total: totalItems,
                    current: currentPage,
                    onChange: handlePageChange,
                    showSizeChanger: false,
                    pageSizeOptions: ["10", "20", "50", "100"],
                    showQuickJumper: false,
                    showTotal: (total, range) =>
                      `${range[0]}-${range[1]} of ${total} items`,
                  }}
                  rowKey="id"
                  bordered
                />
              </div>
            </div>
          </Drawer>
          {/* <Drawer
            title="螺絲BOM"
            placement="bottom"
            height={700}
            width={500}
            onClose={() => setOpenSteelAssembly(false)}
            open={openSteelAssembly}
            extra={
              <Space>
                <Button onClick={() => setOpenSteelAssembly(false)}>Cancel</Button>
                <Button type="primary" onClick={() => setOpenSteelAssembly(false)}>
                  OK
                </Button>
              </Space>
            }
          >
            <div className="flex w-full">
              <div className="w-[25%] p-4">
                <Menu
                  mode="inline"
                  defaultSelectedKeys={['231']}
                  openKeys={stateOpenKeys}
                  onOpenChange={onOpenChange}
                  //style={{ width: 256 }}
                  items={items}
                />
              </div>
              <div className="w-[75%] p-4 overflow-x-auto">
                <div className="flex items-center justify-between w-full gap-4 pb-3">
                  <Dropdown overlay={menu}>
                    <Button className="flex items-center gap-1">
                      排序
                      <IconSortAscending size={16} />
                    </Button>
                  </Dropdown>

                  <TextInput
                    className="w-64" // adjust width as needed
                    leftSection={<IconSearch size={16} />}
                    // onChange={handleInputChange}
                  />
                </div>
                <Table
                  // rowSelection={{
                  //   type: 'checkbox',
                  //   ...rowSelection,
                  // }}
                  scroll={{ x: 'max-content' }}
                  columns={steelBoltColumns}
                  dataSource={steelBoltData}
                  // pagination={{
                  //   pageSize: 25,
                  //   total: designBOM?.meta?.pagination?.total,
                  //   onChange: (e) => fetchData(e),
                  // }}
                  rowKey="id"
                  bordered
                />
              </div>
            </div>
          </Drawer> */}
          <Modal
            open={openProductionResume}
            onCancel={() => setOpenProductionResume(false)}
            footer={null}
            title={t("productionPlan.productionResume") || "生產履歷"}
            width="90%"
            style={{ top: 20 }}
            destroyOnClose
          >
            <ProductionResumeTable projectId={id} />
          </Modal>
          {ifc3d.ifcPreview}
          <Modal
            open={qrCodePopup.visible}
            onCancel={() => setQrCodePopup({ visible: false, guandaId: null, code: null })}
            footer={null}
            title="廣達ID"
            width={240}
          >
            <div className="flex flex-col items-center py-4">
              <QRCode
                value={String(qrCodePopup.guandaId || "0").padStart(7, "0")}
                size={160}
              />
              <div className="mt-3 text-center">
                <div className="text-base font-medium">
                  {String(qrCodePopup.guandaId || "0").padStart(7, "0")}
                </div>
                {qrCodePopup.code && (
                  <div className="text-sm text-gray-500">{qrCodePopup.code}</div>
                )}
              </div>
            </div>
          </Modal>
        </div>
        <Feature flag="genAiChat">
          <ChatBot
            docked
            open={chatOpen}
            onClose={() => setChatOpen(false)}
            chatContext={{
              projectId: id,
              projectName,
              node: selectedNode,
            }}
            onDataChanged={handleAiDataChanged}
          />
        </Feature>
      </div>
    </SelectionProvider>
  );
}

export default ProductionPlan;
